export default function VideoSection() {
  return (
    <section id="video" className="py-20 bg-[#1a1a2e]">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#f97316]/20 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            <i className="ri-play-circle-line"></i>
            See It In Action
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-4">
            Watch Us Walk Through a Real{" "}
            <span className="text-[#f97316]">Insurance Estimate</span>
          </h2>
          <p className="text-white/60 text-base max-w-2xl mx-auto leading-relaxed">
            Most homeowners have never seen what's actually inside their insurance paperwork. In this video, we break down a real estimate line by line — showing you exactly where the money is and how we recover it.
          </p>
        </div>

        {/* Video Embed */}
        <div className="relative rounded-2xl overflow-hidden border border-white/10" style={{ paddingBottom: "56.25%", height: 0 }}>
          <iframe
            src="https://www.loom.com/embed/818857ec99be431e8554cb1ea40613b5"
            frameBorder="0"
            allowFullScreen
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
            title="RidgeCap GC — Walking Through a Real Insurance Estimate"
          ></iframe>
        </div>

        {/* Bottom callout */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-6 bg-white/5 border border-white/10 rounded-xl px-6 py-5">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#f97316]/20 rounded-lg flex-shrink-0">
              <i className="ri-file-search-line text-[#f97316] text-xl"></i>
            </div>
            <div>
              <div className="text-white font-bold text-sm">Have your own estimate?</div>
              <div className="text-white/50 text-xs mt-0.5">We'll review it for free and tell you exactly what you're owed.</div>
            </div>
          </div>
          <a
            href="#cta"
            className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 flex-shrink-0"
          >
            Get a Free Estimate Review
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
